const values = {
	FLICKR_API_KEY: 'dfd8c2b698749aa6f895bc582941ccc3',
	FLICKR_SECRET: 'df2a1bda6566a1c6',
	FLICKR_USER_ID: '70247946@N00',
};

export default values;


// WEBPACK FOOTER //
// ./src/env.js